import { useTranslations } from 'next-intl';

import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import FeaturedTile from '@commons/components/Tile/FeaturedTile';
import { FEATURED_TILE_IMAGE_SIZES } from '@commons/components/Tile/FeaturedTile';

import type { WhitePaperNodeProps } from '.';

/**
 * WhitePaper node component for the Featured Tile display type.
 */

const WhitePaperNodeFeaturedTile = (props: WhitePaperNodeProps) => {
  const t = useTranslations();

  const { title, summary, image, alias, format } = props;

  const upperTitle = format ? format.name : t('nodes.whitePaper.label');

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={FEATURED_TILE_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={FEATURED_TILE_IMAGE_SIZES} />
  );

  return (
    <FeaturedTile
      tag={upperTitle}
      title={title}
      description={summary}
      buttonText={t('commons.learnMore')}
      href={alias}
      image={renderedImage}
      justify="end"
      className="w-100"
    />
  );
};

export default WhitePaperNodeFeaturedTile;
